@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-weight: 500;
  background: none;
  white-space: nowrap;
  transition: all 0.2s;

  &:active,
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 3px solid colorsOld.$sapphireLightX1;
    outline-offset: 1px;
  }
}

// types
.primary {
  background-color: colorsOld.$sapphire;
  border: 1px solid colorsOld.$sapphire;
  color: colorsOld.$white;

  &:hover:not(:disabled) {
    background-color: colorsOld.$sapphireLight;
  }

  &:active:not(:disabled) {
    background-color: colorsOld.$sapphireDark;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: colorsOld.$stoneLightX3;
    color: colorsOld.$stoneLight;
    border-color: colorsOld.$stoneLightX1;
  }

  &.pending {
    background-color: colorsOld.$sapphireLightX4;
    color: colorsOld.$sapphire;
  }
}

.secondary {
  border: 1px solid colorsOld.$stoneLightX1;
  color: colorsOld.$sapphire;

  &:hover:not(:disabled) {
    color: colorsOld.$sapphireLight;
    border-color: colorsOld.$stone;
  }

  &:active {
    border-color: colorsOld.$stoneLight;
    color: colorsOld.$sapphireDark;
  }

  &:disabled {
    cursor: not-allowed;
    color: colorsOld.$stoneLight;
  }

  &.pending {
    color: colorsOld.$sapphireLight;
  }
}

.tertiary {
  border: 1px solid colorsOld.$stoneLightX1;
  color: colorsOld.$stoneDark;

  &:hover:not(:disabled) {
    color: colorsOld.$stoneDarkX1;
  }

  &:active {
    border: 1px solid colorsOld.$stone;
  }

  &:disabled {
    cursor: not-allowed;
    color: colorsOld.$stoneLightX1;
  }

  &.pending {
    color: colorsOld.$stone;
  }
}

.quaternary {
  border: 1px solid colorsOld.$stoneLightX1;
  color: colorsOld.$black;

  &:hover:not(:disabled) {

    border-color: colorsOld.$stone;
  }

  &:active {
    border: 1px solid colorsOld.$stone;
  }

  &:disabled {
    cursor: not-allowed;
    color: colorsOld.$stoneLightX1;
  }

  &.pending {
    color: colorsOld.$stone;
  }
}

.link {
  border: none;
  color: colorsOld.$sapphire;
  display: inline-block;
  font-weight: 400;

  &:hover:not(:disabled) {
    color: colorsOld.$sapphireDark;
  }

  &:disabled {
    cursor: not-allowed;
    color: colorsOld.$stoneLight;
  }
}

.remove {
  background-color: colorsOld.$white;
  color: colorsOld.$rubyDark;
  border: 1px solid colorsOld.$ruby;

  &:hover:not(:disabled) {
    color: colorsOld.$rubyDarkX1;
    border: 1px solid colorsOld.$rubyDark;
  }

  &:active {
    color: colorsOld.$rubyDarkX1;
    border: 2px solid colorsOld.$rubyDarkX1;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: colorsOld.$stoneLightX3;
    color: colorsOld.$stoneLight;
    border: 1px solid colorsOld.$stoneLightX1;
  }
}

.progress {
  background-color: colorsOld.$sapphireLightX4;
  color: colorsOld.$sapphireLight;
}

.completed {
  background-color: colorsOld.$emerald;
  color: colorsOld.$white;
}

.green {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0px;
  background: transparent;
  border: none;
  font-family: "Px Grotesk Mono";
  font-weight: fontsOld.$black-weight;
  font-size: fontsOld.$medium;
  line-height: 110%;
  letter-spacing: -0.01em;
  color: colorsOld.$nanoGreen;
}

.white {
  color: colorsOld.$white;
  cursor: pointer;
}

.black {
  background-color: colorsOld.$black;
  border: 1px solid colorsOld.$black;
  color: colorsOld.$white;
}

// sizes
.jumbo {
  border-radius: 6px;
  padding: 15px 21px;
  gap: 18px;
}

.large {
  border-radius: 4px;
  padding: 9px 15px;
  font-size: 14px;
  gap: 9px;
}

.medium {
  border-radius: 4px;
  padding: 9px 12px;
  font-size: 12px;
  gap: 6px;
}

.small {
  border-radius: 3px;
  padding: 6px 11px;
  font-size: 9px;
  text-transform: uppercase;
  gap: 6px;
}

.xsmall {
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 9px;
  text-transform: uppercase;
  gap: 4px;
}

.none {
  font-size: inherit;
  padding: inherit;
  border: none;
}

.fullWidth {
  width: 100%;
  justify-content: center;
}

.noStyle {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
